import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import SeatSettings from './SeatSettings.js';

// Dependencies
import moment from 'moment';

const CalendarSeats = observer(class CalendarSeats extends React.Component {
    constructor() {
        super();

        this.editSeat = this.editSeat.bind(this);
        this.stopEditing = this.stopEditing.bind(this);
    }

    state = {
        editSeat: false,
        seatSid: ''
    }

    componentDidMount() {
        const { SessionStore, ScheduleStore } = this.props.store;
        const { proctorAccountSid } = SessionStore.userData;

        ScheduleStore.listSeats(proctorAccountSid, this.props.locationSid, null, 'title');
    };

    deleteSeat(seatSid) {
        const { SessionStore, ScheduleStore } = this.props.store;
        const { proctorAccountSid } = SessionStore.userData;

        ScheduleStore.deleteSeat(seatSid, ScheduleStore.listSeats(proctorAccountSid, this.props.locationSid, null, 'title'));
    }

    editSeat(seatSid) {
        this.setState({editSeat: true, seatSid});
    };

    stopEditing() {
        const { SessionStore, ScheduleStore } = this.props.store;
        const { proctorAccountSid } = SessionStore.userData;

        this.setState({ editSeat: false, seatSid: ''});

        // Show newly updated seats
        ScheduleStore.listSeats(proctorAccountSid, this.props.locationSid, null, 'title');
    };

    render() {
        const { translation } = this.props;
        const { ScheduleStore } = this.props.store;
        const calendars = ScheduleStore.locationCalendars;
        const location = ScheduleStore.scheduleLocation;
        const seats = ScheduleStore.locationSeats;
        const filteredCalendars = calendars.filter(calendar => calendar.useSeatManagement);

        return (
                <div className='panel panel--large panel--large-alt'>
                    <button
                        className='btn btn--inline'
                        onClick={() => this.setState({editSeat: true})}
                    >
                        {translation.add}
                    </button>

                    <button
                        className="panel__close"
                        onClick={() => this.props.setStep(1)}
                    >
                        <icons.iconTimes />
                        <span className="meta">{translation.cancel}</span>
                    </button>

                    <h2 className='panel--title'>{`${location.title}'s seats`}</h2>

                    <div className='scrollwrapper'>
                        <table className='table-scrollable seats-table'>
                            <thead>
                                <tr>
                                    <th>{translation.seat.name}</th>
                                    <th>{translation.seat.description}</th>
                                    <th>{translation.seat.upcoming}</th>
                                    <th>{translation.seat.auto_assign}</th>

                                    {filteredCalendars.length > 0 && filteredCalendars.map((calendar, i) => {
                                        return <th key={`calendar-title-${i}`}>{calendar.title}</th>
                                    })}
                                </tr>
                            </thead>

                            <tbody>
                                {seats.length > 0 && seats.map((seat, i) => {
                                    return (
                                        <tr key={`seat-${i}`}>
                                            <td>
                                                <div className='seat-name-cell'>
                                                {seat.title}

                                                <div className='btn-group--flex'>
                                                    <button
                                                        className='btn--reset'
                                                        onClick={() => this.editSeat(seat.sid)}
                                                    >
                                                        <icons.iconSettings />
                                                    </button>
                                                    <button
                                                        className={`btn--reset negative ${
                                                            seat.upcomingAppointmentCount > 0 ? 'disabled' : ''
                                                        }`}
                                                        onClick={() => this.deleteSeat(seat.sid)}
                                                        disabled={seat.upcomingAppointmentCount > 0}
                                                    >
                                                        <icons.iconTrash />
                                                    </button>
                                                </div>
                                                </div>
                                            </td>
                                            <td>{seat.description || ''}</td>
                                            <td>
                                                <div className='center-divide'>
                                                    <p>{seat.upcomingAppointmentCount}</p>
                                                    <p>{seat.nextAppointmentDate ?
                                                        moment(seat.nextAppointmentDate).local().tz(moment.tz.guess()).format('M/DD/YYYY @ h:mma z') :
                                                        'N/A'}
                                                    </p>

                                                </div>
                                            </td>
                                            <td>{seat.autoAssign && <span className='positive icon--lg'><icons.iconCheck /></span>}</td>

                                            {filteredCalendars.length > 0 && filteredCalendars.map((calendar, i) => (
                                                <td key={`calendar-${i}`}>{
                                                    seat.calendarSids.some(seatCalendar => seatCalendar === calendar.sid) &&
                                                        <span className='positive icon--lg'><icons.iconCheck /></span>
                                                }</td>
                                            ))}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    {this.state.editSeat && (
                    <SeatSettings
                        seatSid={this.state.seatSid}
                        seats={seats}
                        store={this.props.store}
                        close={this.stopEditing}
                        calendars={filteredCalendars}
                    />
                )}
                </div>
        )
    };
})

export default translate('CalendarSeats')(CalendarSeats);


// WEBPACK FOOTER //
// ./src/app/components/Schedule/CalendarSeats.js